import { Component } from '@angular/core';

import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
import { HomePage } from '../home/home';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  templateUrl: 'tabs.html',
  standalone: false,
  imports: [
    IonicModule,
//    AboutPage,
//    HomePage,
//    ContactPage,
    TranslateModule,
    CommonModule,
    FormsModule
  ]
})
export class TabsPage {
  public static PATH: string = 'tabs';

  tab1Root = HomePage;
  tab2Root = AboutPage;
  tab3Root = ContactPage;

  constructor() {

  }
}
